import { render, staticRenderFns } from "./ContentViewSettingReview.vue?vue&type=template&id=ab637736&scoped=true&"
import script from "./ContentViewSettingReview.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingReview.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingReview.vue?vue&type=style&index=0&id=ab637736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab637736",
  null
  
)

export default component.exports